<template>
  <ExpandableCard class="ship-order-itinerary loading" expanded>
    <template #default>
      <div class="ship-order-itinerary-header">
        <span class="flex align-items-center font-medium text-gray-darkest">
          {{ t('shipOrders.shipOrderNum') }}
          <Skeleton v-for="i in 4" :key="i" height="1rem" width="1ch" />
        </span>

        <RygenChip :label="t('common.loading')" />
      </div>

      <LocationMarkers hide-location-icons />
    </template>

    <template #expansion>
      <ShipOrderItineraryLoadingPanel />
    </template>
  </ExpandableCard>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import LocationMarkers from '@/components/location/LocationMarkers.vue';
import ShipOrderItineraryLoadingPanel from '@/components/order/itinerary/ShipOrderItineraryLoadingPanel.vue';
import ExpandableCard from '@rygen/rygen-ui/components/ui/ExpandableCard.vue';
import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';
import Skeleton from 'primevue/skeleton';

const { t } = useI18n();
</script>
